import { useContext } from 'react';
import { checkboxPotentialFieldPathsContext } from './context';

export const useCheckboxPotentialFieldPaths = () => {
  const checkboxPotentialFieldPaths = useContext(
    checkboxPotentialFieldPathsContext,
  );
  return checkboxPotentialFieldPaths;
};
